/* istanbul ignore file */
import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Container from "./Container";
import { ClubsPage } from "./pages/ClubsPage";
import { RecipesPage } from "./pages/RecipesPage";
import { PrivacyPolicy } from "./pages/PrivacyPolicy";
import { TermsConditions } from "./pages/TermsConditions";
import { ScrollToTop } from "./components/common/ScrollToTop";

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Container />} />
        <Route path="/clubs" element={<ClubsPage />} />
        <Route path="/recipes" element={<RecipesPage />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<TermsConditions />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
